<app-layout columnCount="3" hAlignment="center" vAlignment="middle">
  <app-layout-title align="start">
    {{ 'AUTH.registration' | translate }}
  </app-layout-title>

  <app-layout-content>
    <form (submit)="register(registryForm)" [formGroup]="registryForm">
      <div class="col-row">
        <mat-form-field>
          <mat-label>{{ 'ACCOUNT.name' | translate }}</mat-label>
          <input formControlName="name" matInput name="name" type="text" required>
          @if (registryForm.get('name')?.hasError('required')) {
            <mat-error>
              {{ 'VALIDATION.required' | translate }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'ACCOUNT.phone' | translate }}</mat-label>
          <input formControlName="phone" matInput name="phone" type="tel">
          @if (registryForm.get('phone')?.hasError('unique')) {
            <mat-error>
              {{ 'VALIDATION.phone_in_use' | translate }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'AUTH.email' | translate }}</mat-label>
          <input formControlName="email" matInput name="email" type="text" required>
          @if (registryForm.get('email')?.hasError('unique')) {
            <mat-error>
              {{ 'VALIDATION.email_in_use' | translate }}
            </mat-error>
          }
          @if (registryForm.get('email')?.hasError('required')) {
            <mat-error>
              {{ 'VALIDATION.required' | translate }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'AUTH.login' | translate }} *</mat-label>
          <input formControlName="login" matInput type="text">
          @if (registryForm.get('login')?.hasError('required')) {
            <mat-error>
              {{ 'VALIDATION.required' | translate }}
            </mat-error>
          }
          @if (registryForm.get('login')?.hasError('minlength')) {
            <mat-error>
              {{ 'VALIDATION.invalid_login' | translate }}
            </mat-error>
          }
          @if (registryForm.get('login')?.hasError('unique')) {
            <mat-error>
              {{ 'VALIDATION.login_in_use' | translate }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'AUTH.password' | translate }}</mat-label>
          <input formControlName="password" matInput type="password" required>
          @if (registryForm.get('password')?.hasError('required')) {
            <mat-error>
              {{ 'VALIDATION.required' | translate }}
            </mat-error>
          }
          @if (registryForm.get('password')?.hasError('minlength')) {
            <mat-error>
              {{ 'VALIDATION.invalid_password' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
      <button color="primary" mat-raised-button type="submit">
        {{ 'AUTH.register' | translate }}
      </button>
    </form>
  </app-layout-content>
</app-layout>
